import React, { useRef, useState } from "react";
import { Form, Button, Card, Alert, InputGroup } from "react-bootstrap";
import { useAuth } from "contexts/AuthContext";
import { Link, useNavigate } from "react-router-dom";
import { MdEmail } from "react-icons/md";
import styles from "styles/auth/auth.module.css";

const ForgotPassword = () => {
  const navigate = useNavigate();
  const emailRef = useRef();

  const { forgotPassword } = useAuth();
  const [error, setError] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [isValid, setIsValid] = useState(false);

  function setEmail() {
    if (emailRef.current.value != "" && isValidEmail(emailRef.current.value)) {
      setIsValid(true);
    } else {
      setIsValid(false);
    }
  }
  function isValidEmail(email) {
    return /\S+@\S+\.\S+/.test(email);
  }
  async function handleSubmit(e) {
    e.preventDefault();

    try {
      setMessage("");
      setError("");
      setLoading(true);
      await forgotPassword(emailRef.current.value);
      setMessage("Check your inbox for futher instructions!");
    } catch (err) {
      setError(err.message);
    }
    setLoading(false);
  }
  return (
    <>
      <Card className="border-0" style={{ backgroundColor: "transparent" }}>
        <Card.Body style={{ width: "100%", backgroundColor: "transparent" }}>
          {error && <Alert variant="danger">{error}</Alert>}
          {message && <Alert variant="success">{message}</Alert>}
          <Form onSubmit={handleSubmit}>
            <Form.Group id="email">
              <InputGroup>
                <Form.Control
                  style={{ height: "3.5rem", borderRadius: "10px" }}
                  type="email"
                  required
                  placeholder="email"
                  ref={emailRef}
                  onChange={(e) => setEmail()}
                ></Form.Control>
              </InputGroup>
            </Form.Group>
            <Form.Label className="d-flex justify-content-end flex-fill form-label">
              <Link className="dark" to="/auth/login">
                Log in
              </Link>
            </Form.Label>
            <Button
              style={{ height: "35px", borderRadius: "10px" }}
              disabled={loading || !isValid}
              className={styles.buttonColor}
              type="submit"
            >
              Reset password
            </Button>
          </Form>
        </Card.Body>
      </Card>
    </>
  );
};
export default ForgotPassword;
